export async function cognitoMultiInfraPromise<T, P extends Promise<T>, R>(
	map: P[],
	onFulfilled: (result: Awaited<P>) => Promise<R>,
	onRejected?: (aggregateError: AggregateError) => Promise<unknown>,
): Promise<R> {
	try {
		const result = await Promise.any(map);
		return await onFulfilled(result);
	} catch (aggregateError) {
		if (!(aggregateError instanceof AggregateError)) {
			throw aggregateError;
		}
		throw (await onRejected?.(aggregateError)) ?? aggregateError;
	}
}
